import React from "react";
import CustomCursor from "../../Global/Cursor";
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header1";
import PageHeader from "../MenTestimonial/PageHeader";
import TestimonialsOne from "../MenTestimonial/TestimonialsOne";
import CtaTwo from "../../Global/Cta";
import Footer_About from "../../Global/Footer1";
import GoToTop from "../../Global/GoToTop";

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader />
            <TestimonialsOne />
            <CtaTwo />
            <Footer_About />
            <GoToTop />
        </>
    )
}
export default Main;